<template>
    <div class="first">
        <div class="close_top" @click="close = !close">
            <div>
                <h3>Dokumenty</h3>
                <p>
                    {{ $t('offer.files_hint') }}
                </p>
            </div>
            <div>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="27"
                    height="28"
                    viewBox="0 0 27 28"
                    fill="none"
                    :class="close ? 'rotate' : ''"
                >
                    <path
                        d="M21.2543 10.9573L13.48 18.8206L5.70562 10.9573"
                        stroke="#263544"
                        stroke-width="0.699172"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </div>
        </div>
        <!-- <div v-if="!premium.id" class="noPremium">
            <p class="top_left">DOKUMENTY</p>
            <div class="ColorBox">
                <svg width="21" height="14" viewBox="0 0 21 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.21746 1.0767L6.181 4.0062L9.71225 0.353954C9.81113 0.251851 9.93616 0.169801 10.078 0.113916C10.2199 0.0580307 10.3749 0.0297499 10.5316 0.0311796C10.6883 0.0326092 10.8426 0.0637127 10.983 0.122173C11.1234 0.180634 11.2462 0.264945 11.3425 0.368829L14.7123 4.00533L18.8039 1.03383C18.9646 0.917375 19.1638 0.844926 19.3748 0.826176C19.5859 0.807427 19.7987 0.843272 19.9848 0.928915C20.171 1.01456 20.3215 1.14591 20.4163 1.3054C20.5111 1.46488 20.5457 1.64489 20.5154 1.82133L18.9529 10.875H2.08517L0.49871 1.86245C0.467197 1.68504 0.501361 1.50377 0.596575 1.3432C0.691789 1.18264 0.843452 1.05053 1.03102 0.964782C1.21859 0.879031 1.43301 0.843778 1.64522 0.863798C1.85744 0.883817 2.0572 0.958142 2.21746 1.0767ZM2.16642 11.75H18.8331V12.625C18.8331 12.857 18.7233 13.0796 18.528 13.2437C18.3326 13.4078 18.0677 13.5 17.7914 13.5H3.20809C2.93182 13.5 2.66687 13.4078 2.47152 13.2437C2.27617 13.0796 2.16642 12.857 2.16642 12.625V11.75Z" fill="#FBBF24"/>
                </svg>
                <div>
                    {{ $t('offer.files_premium_msg') }}
                </div>
            </div>
        </div> -->
        <div v-show="!close" class="close_bottom">
            <form
                action=""
                method="post"
                enctype="multipart/form-data"
                class="offer_file mt-4"
            >
                <input
                    type="file"
                    name="files"
                    class="files"
                    :data-fileuploader-files="preloadedofferfiles"
                />
            </form>
        </div>
    </div>
</template>

<script>
export default {
    props: ["preloadedofferfiles", "uuidOffer", "premium"],
    data() {
        return {
            files: [],
            close: false,
        };
    },
    created() {
        if (this.preloadedofferfiles == "[]") this.close = true;
        if (this.preloadedofferfiles == "") this.close = true;
        var t = this;
        $(document).ready(function () {
            $.ajaxSetup({
                headers: {
                    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                        "content"
                    ),
                },
            });
            $(".offer_file input.files").fileuploader({
                addMore: true,
                limit: 5,
                extensions: [
                    "zip",
                    "docx",
                    "doc",
                    "rar",
                    "jpeg",
                    "jpg",
                    "png",
                    "pdf",
                    "csv",
                    "xls",
                    "xlsx",
                ],
                fileMaxSize: 4,
                changeInput:
                    '<div class="fileuploader-input">' +
                    '<span class="top_left">DOKUMENTY</span>' +
                    '<div class="fileuploader-input-inner">' +
                    '<div class="fileuploader-icon-main"></div>' +
                    '<h3 class="fileuploader-input-caption"><span>${captions.feedback}</span></h3>' +
                    "<p>${captions.or}</p>" +
                    "</div>" +
                    "</div>",
                theme: "dragdrop",
                thumbnails: {
                    onImageLoaded: function (item) {
                        if (item.appended) {
                            t.files.push(item);
                        } else {
                            item.html
                                .find(".column-title span")
                                .html("Nahrávanie...");
                            const fd = new FormData();
                            fd.append("file", item.file);
                            fd.append("offer_uuid", t.uuidOffer);
                            axios
                                .post("/api/offers/offer/file/save", fd)
                                .then((response) => {
                                    item.html
                                        .find(".column-title span")
                                        .html(item.size2);
                                    t.files.push(item);
                                });
                        }
                    },
                },
                editor: {
                    cropper: {
                        showGrid: true,
                    },
                },
                captions: $.extend(
                    true,
                    {},
                    $.fn.fileuploader.languages["en"],
                    {
                        feedback:
                            t.$t('offer.files_upload_feedback'),
                        feedback2:
                            t.$t('offer.files_upload_feedback'),
                        drop: t.$t('offer.files_upload_feedback'),
                        or: "",
                        button: "",
                        remove: t.$t('offer.files_remove'),
                        download: t.$t('offer.files_download'),
                        removeConfirmation: t.$t('offer.files_remove_confirm'),
                        errors: {
                            filesLimit: function (e) {
                                t.$toast.warning(
                                    t.$t('offer.files_only_five'),
                                    {
                                        timeout: 5000,
                                    }
                                );
                            },
                            filesType: function (e) {
                                t.$toast.warning(
                                    t.$t('offer.files_invalid_type'),
                                    {
                                        timeout: 5000,
                                    }
                                );
                            },
                            fileSize: function (e) {
                                t.$toast.warning(
                                    e.name +
                                        t.$t('offer.files_too_large_suffix') +
                                        e.fileMaxSize +
                                        " MB.",
                                    {
                                        timeout: 5000,
                                    }
                                );
                            },
                        },
                    }
                ),
                onRemove: function (item) {
                    item.html.find(".column-title span").html("Odstranenie...");
                    if (item.appended) {
                        axios
                            .post("/api/offers/offer/file/remove", {
                                item: item,
                                offer_uuid: t.uuidOffer,
                            })
                            .then((response) => {
                                for (var i = 0; i < t.files.length; i++) {
                                    if (t.files[i] == item) {
                                        t.files.splice(i, 1);
                                        i--;
                                    }
                                }
                            });
                    } else {
                        const fd = new FormData();
                        fd.append("file", item.file);
                        fd.append("offer_uuid", t.uuidOffer);
                        axios
                            .post("/api/offers/offer/file/remove", fd)
                            .then((response) => {
                                for (var i = 0; i < t.files.length; i++) {
                                    if (t.files[i] == item) {
                                        t.files.splice(i, 1);
                                        i--;
                                    }
                                }
                            });
                    }
                },
            });
        });
    },
};
</script>

<style lang="scss">
.offer_file {
    .fileuploader {
        background: transparent;
        margin: 0;
        padding: 0;
    }
    .fileuploader-theme-dragdrop .fileuploader-input {
        position: relative;
        border: 1px dashed #dde3e8;
        padding: 15px;
        height: 91px;
        @media (max-width: 600px) {
            height: 110px !important;
            .fileuploader-input-caption{
                flex: 1 !important;
            }
        }
        .top_left {
            position: absolute;
            left: 15px;
            top: 15px;
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 11px;
            line-height: 13px;
            letter-spacing: 0.1em;
            text-transform: uppercase;
            color: #9598a7;
        }
        .fileuploader-input-inner {
            margin-top: 14px;
            height: 100%;
            display: flex;
            align-items: center;
        }
    }
    .fileuploader-theme-dragdrop .fileuploader-input .fileuploader-icon-main {
        margin: 0;
        font-size: 32px;
    }
    h3.fileuploader-input-caption {
        margin: 0;
        display: block;
        flex: none;
        align-self: center;
        margin-left: 10px;
        font-family: Roboto;
        font-style: normal;
        font-size: 14px;
        line-height: 16px;
        span {
            font-weight: normal;
            color: #263544;
        }
        .nahraj {
            font-weight: 600;
            color: #2ed8b6;
            text-decoration: underline;
        }
    }
}
</style>
<style lang="scss" scoped>
.first {
    padding: 17px 20px;
}
.close_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    svg {
        transition: all 0.2s;
        cursor: pointer;
        transform: rotate(-90deg);
    }
    svg.rotate {
        transform: rotate(0deg);
    }
}
.close_bottom {
    transition: all 0.5s;
    padding-bottom: 5px;
}
.noPremium {
    margin-top: 15px;
    border-radius: 20px;
    position: relative;
    width: 526px;
    @media screen and (max-width: 700px) {
        width: auto;
    }
    position: relative;
    border: 1px dashed #dde3e8;
    padding: 15px;
    height: 100px;
    .top_left {
        position: absolute;
        left: 10px;
        top: 9px;
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 11px;
        line-height: 13px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #9598a7;
    }
    .ColorBox {
        position: absolute;
        top: 16px;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 510px;
        height: 41px;
        background: #fff7ed;
        border: 1px solid #fbbf24;
        box-sizing: border-box;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        @media screen and (max-width: 700px) {
            width: auto;
            height: fit-content;
            padding: 5px;
        }
        svg {
            width: 21px;
            height: 14px;
            margin-right: 13px;
        }
        div {
            font-family: Roboto;
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 19px;
            color: #9a3412;
            b {
                font-weight: 600;
            }
            a {
                font-weight: 600;
                text-decoration: underline;
                color: #9a3412;
                &:hover {
                    color: #9a3412;
                    text-decoration: underline;
                }
            }
        }
    }
}
form {
    width: 100%;
    margin: 0 auto;
    @media only screen and (max-width: 600px) {
        width: 95%;
    }
}
.form-floating {
    margin-top: 20px;
}
h3 {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 21px;
    color: #212541;
}
p {
    margin-top: 7px;
    margin-bottom: 0px;

    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;

    color: #9598a7;
}
.form-floating > label {
    padding: 22px 13px;

    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #9598a7;
}
input {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;

    color: #212541;

    border: 1px solid #dde3e8;
    border-radius: 0;
}
label {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #212541;
}
input[type="checkbox"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
    margin: 0px 10px 0 0px;
    background: #c7d4eb;
    border-radius: 25px;
}
.toggle label {
    @media (max-width: 600px) {
        width: 70%;
    }
}
.toggle {
    height: 22px;
    width: 40px;
    display: inline-block;
    position: relative;
    margin: 0;
    border: none;
    background: #ffffff;
    border-radius: 3px;
    transition: all 0.2s ease;
    &:focus {
        outline: 0;
    }
    &:after {
        content: "";
        position: absolute;
        top: 4px;
        left: 3px;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: white;
        box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
        transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
    }
    &:checked {
        border-color: #2ed8b6;
        background: #2ed8b6;
    }
    &:checked:after {
        transform: translatex(20px);
    }
}
.mobile_doba_inputs {
    display: grid !important;
}
.doba_inputs {
    background: white;
    padding: 20px;
    width: 100%;
    @media (max-width: 550px) {
        margin: 20px 0 !important;
    }
    .form-floating > label,
    .float-container label {
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 11px;
        line-height: 13px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #9598a7;
    }
    input {
        height: 50px;
        border-radius: 0;
    }
    textarea {
        border-radius: 0;
    }
}
.info {
    position: relative;
    height: 20px;
    margin-left: 10px;
    .info_icon {
        pointer-events: all;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        float: right;
        img {
            width: 80%;
            height: 80%;
        }
    }
    .my_tooltip {
        bottom: 22px;
        right: -7px;
    }
}
.agree_tooltip {
    position: relative;
}
.my_tooltip {
    pointer-events: none;
    opacity: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 300px;
    background: #f3385a;
    box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
    border-radius: 6px;
    font-weight: 800;
    font-size: 14px;
    line-height: 18px;
    color: #fff;
    padding: 10px;
    position: absolute;
    top: unset;
    right: 15px;
    z-index: 10000;
    transition: opacity 0.5s ease-in-out;
    &::after {
        content: "";
        width: 15px;
        height: 15px;
        background: #f3385a;
        position: absolute;
        right: 10px;
        bottom: -3px;
        transform: rotate(45deg);
        border-radius: 3px;
    }
}
</style>
